// Quantity validation to prevent adding 0 quantity to cart
document.addEventListener('DOMContentLoaded', function() {
  // Function to validate quantity
  function validateQuantity(form) {
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (quantityInput) {
      const quantity = parseInt(quantityInput.value) || 0;
      if (quantity <= 0) {
        return false;
      }
    }
    return true;
  }

  // Function to show error message
  function showQuantityError(form) {
    const errorDiv = form.querySelector('.m-product-form-message') || form.querySelector('.product-form__error-message-wrapper');
    if (errorDiv) {
      errorDiv.innerHTML = '<div class="product-form__error-message" role="alert"><span>Please select a quantity greater than 0</span></div>';
      errorDiv.style.display = 'block';
      
      // Hide error after 3 seconds
      setTimeout(() => {
        errorDiv.style.display = 'none';
        errorDiv.innerHTML = '';
      }, 3000);
    }
  }

  // Add validation to all product forms
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if this is a product form (add to cart form)
    if (form.matches('form[action*="/cart/add"]') || 
        form.matches('[data-type="add-to-cart-form"]') ||
        form.closest('product-form')) {
      
      if (!validateQuantity(form)) {
        e.preventDefault();
        e.stopPropagation();
        showQuantityError(form);
        return false;
      }
    }
  }, true); // Use capture phase to intercept before other handlers

  // Also handle quantity input changes to prevent 0
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="quantity"]')) {
      const input = e.target;
      const value = parseInt(input.value) || 0;
      
      // Set minimum value to 1 if it's 0 or less
      if (value <= 0) {
        input.value = input.min || 1;
      }
    }
  });

  // Handle minus button clicks to prevent going below 1
  document.addEventListener('click', function(e) {
    if (e.target.closest('button[name="minus"]')) {
      const button = e.target.closest('button[name="minus"]');
      const quantityInput = button.closest('m-quantity-input')?.querySelector('input[name="quantity"]');
      
      if (quantityInput) {
        setTimeout(() => {
          const value = parseInt(quantityInput.value) || 0;
          if (value <= 0) {
            quantityInput.value = quantityInput.min || 1;
          }
        }, 10); // Small delay to let the default handler run first
      }
    }
  });
});